import React from 'react'
import { SlideCardData } from '../types'
import classnames from 'classnames'
import styles from './SlideCard.module.scss'
import Thumbnail from '@bt-react/components/Thumbnail'

class SlideCard extends React.PureComponent<SlideCardData> {

  render () {

    const { url = '',
      selected = false,
      index = 0,
      onClick = () => {} } = this.props

    return <div
      className={classnames({
        [styles['slide-card']]: true,
        [styles['slide-card-selected']]: selected
      })}
      data-bdd={selected ? 'slide-card-selected' : 'slide-card'}
      onClick={ () => onClick && onClick(index, this.props.presenterLayoutActive, this.props.mediaType) }>
      <div
        className={styles['image-wrapper']}>
        <Thumbnail
          src={url}
          alt={`Slide ${index}`}
        />
      </div>
      <p data-bdd='slide-card-number'>
        {index}
      </p>
    </div>

  }

}

export default SlideCard
